import { LanguageInfo } from '../types';

export const SUPPORTED_LANGUAGES: Record<string, LanguageInfo> = {
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English (Nigeria)',
    region: 'National / Official Lingua Franca',
    speakers: 'Widely used across all 36 Nigerian states and FCT Abuja',
    status: 'verified',
    flagEmoji: '🇳🇬',
    linguisticNotes: 'Standard Nigerian English curriculum with local financial and telecom context.',
  },
  ha: {
    code: 'ha',
    name: 'Hausa',
    nativeName: 'Harshen Hausa',
    region: 'Northern Nigeria (Kano, Kaduna, Sokoto, Katsina, Borno, etc.)',
    speakers: 'Over 50+ million native speakers in Nigeria and West Africa',
    status: 'verified',
    flagEmoji: '🇳🇬',
    linguisticNotes: 'Standard Hausa orthography with authentic financial and digital terminology.',
  },
  yo: {
    code: 'yo',
    name: 'Yoruba',
    nativeName: 'Èdè Yorùbá',
    region: 'South-Western Nigeria (Lagos, Oyo, Ogun, Osun, Ondo, Ekiti, Kwara)',
    speakers: 'Over 45+ million speakers with rich literary orthography',
    status: 'verified',
    flagEmoji: '🇳🇬',
    linguisticNotes: 'Standard literary Yoruba with proper tonal markings and digital terms.',
  },
  ig: {
    code: 'ig',
    name: 'Igbo',
    nativeName: 'Asụsụ Igbo',
    region: 'South-Eastern Nigeria (Enugu, Anambra, Imo, Abia, Ebonyi, Delta)',
    speakers: 'Over 35+ million speakers across Eastern Nigeria and commercial hubs',
    status: 'verified',
    flagEmoji: '🇳🇬',
    linguisticNotes: 'Standard Central Igbo orthography with authentic modern vocabulary.',
  },
  tiv: {
    code: 'tiv',
    name: 'Tiv',
    nativeName: 'Zwa Tiv',
    region: 'North-Central Nigeria & Benue Valley (Benue, Taraba, Nasarawa)',
    speakers: 'Over 5+ million speakers in the Middle Belt of Nigeria',
    status: 'review_required',
    flagEmoji: '🇳🇬',
    linguisticNotes: 'Core introductory terms reviewed. Deep lesson sections fallback cleanly to verified English pending native linguist validation.',
  },
  ikd: {
    code: 'ikd',
    name: 'Ikede / Igede',
    nativeName: 'Ikede (Igede)',
    region: 'Middle Belt & Benue Valley (Oju, Obi, Benue & Cross River border)',
    speakers: 'Over 500,000+ speakers in Central/Eastern border communities',
    status: 'review_required',
    flagEmoji: '🇳🇬',
    linguisticNotes: 'Verified regional context and introductory phrases. Deep technical curriculum displays English reference to maintain accuracy.',
  },
};

export const DEFAULT_LANGUAGE = 'en';
